export default __webpack_public_path__ + "static/media/intelli-menu.a43ff7be.png";